<template>
    <div id="team-detail">

        <create-sidebar :isSidebarActive="editDataSidebar" :model="false" :rule="team" @closeSidebar="initEditSideBar" />

        <vx-card>
            <!-- INVOICE METADATA -->
            <div class="vx-row leading-loose p-base">
                <div class="vx-col w-full md:w-1/2">
                    <img v-if="team.imgSrc != ''" :src="team.imgSrc" :alt="team.teamName" class="w-full md:w-1/2">
                    <img v-else :src="require('@/assets/images/team/default_team.png')" :alt="team.teamName" class="w-full md:w-1/2">
                </div>
                <div class="vx-col w-full md:w-1/2 text-right mt-base">
                    <h1>{{ team.teamName }}</h1>
                    <div class="invoice__invoice-detail mt-6">
                        <h6>口号</h6>
                        <p>{{ team.teamSlogan }}</p>
                    </div>
                </div>
            </div>
            
            <div class="px-base flex justify-end" v-if="checkoutViewType">
              <vs-button color="success" type="relief" icon-pack="feather" icon="icon-zap" @click="activeFastMemberPrompt = true">快速注册成员</vs-button>
              <vs-button type="relief" icon-pack="feather" icon="icon-user-plus" class="ml-4" @click="initAddMemberDialog">邀请新成员</vs-button>
              <vs-button color="warning" type="relief" icon-pack="feather" icon="icon-user-plus" class="ml-4" @click="editDataSidebar = true">编辑团队信息</vs-button>
            </div>
            <vs-divider class="px-base text-xl font-medium" position="left">成员信息</vs-divider>
            <!-- INVOICE CONTENT -->
            <div class="px-base" style="white-space: nowrap;">
                <!-- INVOICE TASKS TABLE -->
                <vs-table hoverFlat :data="members">
                    <!-- HEADER -->
                    <template slot="thead">
                        <vs-th>成员</vs-th>
                        <vs-th>账号</vs-th>
                        <vs-th>详情</vs-th>
                        <vs-th v-if="checkoutViewType">操作</vs-th>
                    </template>

                    <!-- DATA -->
                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, index) in data" :key="index">
                            <vs-td>
                              <ul class="flex items-center pr-base">
                                <li>
                                  <vs-avatar v-if="data[index].avatar" :src="data[index].avatar" size="small" />
                                  <vs-avatar v-else size="small" :src="require('@/assets/images/profile/default-avatar.png')" />
                                  </li>
                                <li>{{ data[index].nickname }}</li>
                              </ul>
                            </vs-td>
                            <vs-td :data="data[index].username" v-if="index != 0">{{ data[index].username }}</vs-td>
                            <vs-td :data="data[index].username" v-else><vs-chip class="mr-2">队长</vs-chip><span class="inline-block pt-1">{{ data[index].username }}</span></vs-td>
                            <vs-td :data="data[index].detail">{{ data[index].detail }}</vs-td>
                            <vs-td v-if="checkoutViewType" class="md:w-1/4">
                              <div class="flex">
                                <!-- <vs-button color="primary" icon-pack="feather" size="small" icon="icon-edit-2" class="mr-4">编辑成员详情</vs-button> -->
                                <vs-button color="danger" icon-pack="feather" size="small" icon="icon-user-x" v-if="index != 0" @click="showDelDialog(index)">移除成员</vs-button>
                              </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
            <vs-divider v-if="team.matchName" class="px-base text-xl font-medium" position="left">参赛记录</vs-divider>
            <div v-if="team.matchName" class="flex justify-between px-12">
              <span>{{ team.matchName }}</span>
              <span v-if="team.status == 2">报名中</span>
              <span v-else-if="team.status == 3">进行中</span>
              <span v-else-if="team.status == 4">已结束</span>
            </div>
            
        </vx-card>

        <vs-prompt
          vs-title="邀请新成员"
          vs-accept-text="邀请"
          vs-cancel-text="取消"
          @vs-accept="addMemberToTeam"
          :vs-active.sync="activeAddMemberPrompt"
        >
          <vx-input-group>
            <vs-input placeholder="请输入新成员用户名" v-model="waitSearchUsername" />
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button @click="searchUserByUsername">搜索</vs-button>
              </div>
            </template>
          </vx-input-group>
          <vs-alert class="mt-2" :active="!waitSearchUsername" color="danger" icon="new_releases" >
            用户名不能为空哟！
          </vs-alert>
          <vx-card v-if="searchUser" class="md:w-1/2 text-center mx-auto mt-4">
            <vs-avatar
              size="100px"
              :src="require('@/assets/images/profile/default-avatar.png')"
              v-if="!searchUser.avatar"
            />
            <vs-avatar
              size="100px"
              :src="searchUser.avatar"
              v-else
            />
            <p>{{searchUser.username}}</p>
          </vx-card>
        </vs-prompt>

        <vs-prompt
          vs-title="快速注册新成员"
          vs-accept-text="添加"
          vs-cancel-text="取消"
          @vs-accept="fastMemberToTeam"
          :vs-is-valid="validateForm"
          :vs-active.sync="activeFastMemberPrompt"
        >
          <vs-input 
            v-validate="'required|alpha_dash|min:3'"
            data-vv-validate-on="blur"
            name="username"
            label="用户名" 
            class="w-full" 
            placeholder="请输入新成员的用户名" 
            v-model="fastUser.account" />
          <span class="text-danger text-sm">{{ errors.first('username') }}</span>
          <vs-input 
            ref="password"
            type="password"
            data-vv-validate-on="blur"
            v-validate="'min:6|max:18'"
            name="password"
            label="密码" 
            class="w-full mt-2" 
            placeholder="请输入密码" 
            v-model="fastUser.password" />
          <span class="text-danger text-sm">{{ errors.first('password') }}</span>
          <vs-alert class="mt-4" color="warning" :active="true" iconPack="feather" icon="icon-info">密码不提默认为:08980899</vs-alert>
        </vs-prompt>
    </div>
</template>

<script>

import { Validator } from 'vee-validate'
import { memberList, addMember, delMember, addFastMember } from '@/api/team'
import { searchUser } from '@/api/user'
import { getToken } from '@/utils/tools'
import CreateSidebar from '@/views/team/components/CreateSidebar' 

const dict = {
    custom: {
        username: {
            required: '请输入你的用户名',
            alpha_dash: '你的用户名不能包含特殊字符，允许的字符字母及数字',
            min: '用户名不能小于三个字符'
        },
        password: {
            min: '密码的长度小于6',
            max: '密码的长度不能大于18'
        },
    }
}

Validator.localize('zh', dict)

export default{
    data() {
        return {
            team: {},
            members: [],
            viewType: 'create',
            activeAddMemberPrompt: false,
            activeFastMemberPrompt: false,
            waitSearchUsername: '',
            searchUser: null,
            waitDelMemberIndex: null,
            editDataSidebar: false,
            fastUser: {
              account: '',
              password: '',
            },
        }
    },
    created() {
      this.viewType = this.$route.query.type
      if (this.viewType === 'create') {
        this.$route.meta.breadcrumb[1].title = '创建的团队'
        this.$route.meta.breadcrumb[1].url = '/team/create-list'
      } else {
        this.$route.meta.breadcrumb[1].title = '加入的团队'
        this.$route.meta.breadcrumb[1].url = '/team/join-list'
      }
      
      this.team = JSON.parse(this.$route.query.team)
      this.getList()
    },
    computed: {
      checkoutViewType() {
        return (this.viewType == 'create')?true:false
      },
      validateForm() {
          return !this.errors.any() && this.fastUser.account != '';
      }
    },
    methods: {
      initAddMemberDialog() {
        this.activeAddMemberPrompt = true
        this.waitSearchUsername = ''
        this.searchUser = null
      },
      initEditSideBar(obj) {
        this.editDataSidebar = false
        Object.assign(this.team, obj)
      },
      getList() {
        let that = this
        memberList({
          access_token: getToken(),
          teamId: that.team.id
        }).then((res) => {
          const data = res.data;
          that.members = that.$lodash.cloneDeep(data.list);
        })
      },
      fastMemberToTeam() {
        let that = this
        if (!that.validateForm) {
          return
        }
        let obj = Object.assign({
          access_token: getToken(),
          teamId: that.team.id,
        }, that.fastUser)
        addFastMember(obj).then((res) => {
          if (res.data.err_code == 0) {
            that.$vs.notify({
              color: 'success',
              title: '提示',
              text: '添加成员成功！',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            }),
            that.getList()
          }
        })
      },
      addMemberToTeam() {
        let that = this
        if (!that.waitSearchUsername) {
          return
        }
        addMember({
          access_token: getToken(),
          teamId: that.team.id,
          memberId: that.searchUser.id,
        }).then((res) => {
          if (res.data.err_code == 0) {
            that.getList()
          }
        })
      },
      searchUserByUsername() {
        let that = this
        if (!that.waitSearchUsername) {
          return
        }
        searchUser({
          access_token: getToken(),
          username: that.waitSearchUsername,
        }).then((res) => {
          if (res.data.user !== undefined) {
            that.searchUser = res.data.user
          } else {
            that.searchUser = null
          }
        })
      },
      showDelDialog(index) {
        let that = this
        that.waitDelMemberIndex = index
        that.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: '移除成员',
          text: '确认要从团队中移除这个成员吗？',
          accept: that.deleteMember,
          acceptText: '是的',
          cancelText: '我再想想'
        })
        
      },
      deleteMember() {
        let that = this
        delMember({
          access_token: getToken(),
          teamId: that.team.id,
          memberId: that.members[that.waitDelMemberIndex].id,
        }).then((res) => {
          if (res.data.err_code == 0) {
            that.members.splice(that.waitDelMemberIndex, 1)
          }
        })
      }
    },
    components: {
      CreateSidebar,
    }
}
</script>